import { useState } from "react";
import { format } from "date-fns";
import Button from "../../Custom/Button/Button";
import CloseIcon from "@mui/icons-material/Close";
import "./forwardMessage.css";
import { useGlobalContext } from "../../../Context/Context";
import axios from "axios";
import { useEffect } from "react";

const ForwardMessage = ({
  setIsForward,
  setSelectedMessage,
  selectedMessage,
  isFullVisible,
  localChat,
  setLocalChat,
  currentTab,
  selectedCompany,
}) => {
  const [dataChat, setDataChat] = useState([]);
  const loggedUser = "Zikica Petkovic";
  const [selectedChat, setSelectedChat] = useState(null);
  const { baseUrl } = useGlobalContext();
  const {
    currentChatAdmin,
    setCurrentChatAdmin,
    activeIconsMiddleAdmin,
    setActiveIconsMiddleAdmin,
  } = useGlobalContext();

  const handleForward = async () => {
    if (selectedChat === null) return;

    const correctChat = dataChat.find((chat) => chat.id === selectedChat);

    //Ovde treba poziv za dodavanje porukue novom
    try {
      //console.log(currentChat);
      //console.log(newMessage);
      const dataForward = await axios.post(
        `${baseUrl}/admin_panel/chat/getAllMessages.php`,
        {
          external_user_id: selectedCompany.company_chat_profile_id,
          chat_room_id: correctChat.id,
          api_key_company: selectedCompany.external_api_key,
        }
      );
      console.log(dataForward.data);
      console.log(currentChatAdmin);
      const dataSend = await axios.post(
        `${baseUrl}/admin_panel/chat/sendMessage.php`,
        {
          sender: selectedCompany.company_name,
          text: selectedMessage.data.text,
          date: format(new Date(), "dd.MM.yyyy HH:mm"),
          chat_room_id: parseInt(correctChat.id),
          api_key: selectedCompany.external_api_key,
          // external_user_id: selectedCompany.company_chat_profile_id,
        }
      );

      let messageId = dataSend.data.message_id;

      let newMessage = {
        id: messageId,
        sender: loggedUser.user_email,
        sender_id: parseInt(loggedUser.id),
        text: selectedMessage.data.text,
        date: format(new Date(), "dd.MM.yyyy HH:mm"),
        apiKey: selectedCompany.external_api_key,
      };

      if (selectedMessage.data.reply !== "") {
        const { data } = await axios.post(
          `${baseUrl}/admin_panel/chat/sendReply.php`,
          {
            user_id: parseInt(selectedCompany.company_chat_profile_id),
            message_id: parseInt(messageId),
            reply_text: selectedMessage.data.text,
            api_key: selectedCompany.external_api_key,
          }
        );

        if (data.status === 200) {
          newMessage = {
            ...newMessage,
            reply: {
              sender: selectedMessage.data.sender,
              text: selectedMessage.data.text,
            },
          };
          setSelectedMessage({ value: false, data: "" });
        }
      } else {
        newMessage = {
          ...newMessage,
          reply: "",
        };
      }
      console.log(newMessage);
      if (dataForward.data.status === 200) {
        const newMessages = [...dataForward.data.messages, newMessage];

        //localStorage.setItem("messages", JSON.stringify(newData));//ovde treba poziv za citanje novog sve poruke
        // if (localChat.id === dataForward.data.other_user_id)
        setLocalChat({ ...localChat, messages: newMessages });

        // if (correctChat.id === dataForward.data.other_user_id)
        setCurrentChatAdmin({ ...currentChatAdmin, messages: newMessages });

        /*
        let currentActive = activeIconsMiddle.find(
          (icon) => icon.name === currentTab
        );
        if (currentActive.data.id === correctChat.id) {
          const correctData = { ...currentActive.data, messages: newMessages };
          const newIconsMiddle = activeIconsMiddle.map((icon) => {
            if (currentTab === icon.name)
              return {
                name: icon.name,
                data: correctData,
              };
            else return icon;
          });
          setActiveIconsMiddle(newIconsMiddle);
        }*/

        setIsForward(false);
        setSelectedMessage({ value: false, data: "" });
      }
    } catch (error) {
      console.log(error);
    }
  };

  /* const handleForward = () => {
    if (selectedChat === null) return;
    const correctChat = dataChat.find((chat) => chat.id === selectedChat);
    let newMessage = {
      id: correctChat.messages.length + 1,
      sender: loggedUser,
      text: selectedMessage.data.text,
      date: format(new Date(), "dd.MM.yyyy hh:mm"),
      reply: selectedMessage.data.reply,
    };
    const newMessages = [...correctChat.messages, newMessage];
    const newData = dataChat.map((chat) => {
      if (chat.id === correctChat.id) {
        return { ...chat, messages: newMessages };
      } else return chat;
    });
    localStorage.setItem("messages", JSON.stringify(newData));
    if (localChat.id === correctChat.id)
      setLocalChat({ ...localChat, messages: newMessages });
    if (correctChat.id === currentChat.id)
      setCurrentChat({ ...currentChat, messages: newMessages });
    let currentActive = activeIconsMiddle.find(
      (icon) => icon.name === currentTab
    );
    if (currentActive.data.id === correctChat.id) {
      const correctData = { ...currentActive.data, messages: newMessages };
      const newIconsMiddle = activeIconsMiddle.map((icon) => {
        if (currentTab === icon.name)
          return {
            name: icon.name,
            data: correctData,
          };
        else return icon;
      });
      setActiveIconsMiddle(newIconsMiddle);
    }
    setIsForward(false);
    setSelectedMessage({ value: false, data: "" });
  };
*/

  useEffect(() => {
    console.log(selectedCompany);
    const fetchMessageList = async () => {
      try {
        const { data } = await axios.post(
          `${baseUrl}/admin_panel/chat/getChatRoomsForExternalUser.php`,
          {
            external_user_id: selectedCompany.company_chat_profile_id,
            api_key_company: selectedCompany.external_api_key,
          }
        );
        console.log(data);
        if (data.status === 200) {
          setDataChat(data.data);
        }
      } catch (e) {
        console.log(e);
        if (e.status === 404) {
        }
      }
    };
    fetchMessageList();
  }, []);

  return (
    <div className={!isFullVisible ? "msg-forward" : "msg-forward mini"}>
      <div className="msg-forward-wrapper">
        <div className="msg-forward-header">
          <h4>Prosledi poruku:</h4>
          <div className="msg-cancel" onClick={() => setIsForward(false)}>
            <Button>
              <CloseIcon />
            </Button>
          </div>
        </div>
        <div className="msg-forward-chats">
          {dataChat.map((userChat) => {
            return (
              <span
                className={
                  selectedChat === userChat.id
                    ? "msg-user selected"
                    : "msg-user"
                }
                key={userChat.id}
                onClick={() => setSelectedChat(userChat.id)}
              >
                {userChat.name}
              </span>
            );
          })}
        </div>
        <div className="msg-forward-btn" onClick={handleForward}>
          <Button activation={true}>Prosledi</Button>
        </div>
      </div>
    </div>
  );
};

export default ForwardMessage;
